import { Dropdown, MenuProps } from 'antd'

type Props = {
  options?: MenuProps['items']
}

export const TableActions = ({ options = [] }: Props) => {
  // With nothing to offer there is no point in a trigger that opens an empty
  // menu — read-only views rely on this to drop their actions cell.
  if (!options.length) return null

  return (
    <Dropdown.Button
      trigger={['click']}
      menu={{ items: options }}
      buttonsRender={(btns) => [null, btns[1]]}
    />
  )
}
